import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { ISearchQuery } from 'app/shared/model/search-query.model';
import { getEntities as getSearchQueries } from 'app/entities/search-query/search-query.reducer';
import { IAdvancedMaterial } from 'app/shared/model/advanced-material.model';
import { getEntity, updateEntity, createEntity, reset } from './advanced-material.reducer';

export const AdvancedMaterialUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const searchQueries = useAppSelector(state => state.searchQuery.entities);
  const advancedMaterialEntity = useAppSelector(state => state.advancedMaterial.entity);
  const loading = useAppSelector(state => state.advancedMaterial.loading);
  const updating = useAppSelector(state => state.advancedMaterial.updating);
  const updateSuccess = useAppSelector(state => state.advancedMaterial.updateSuccess);

  const handleClose = () => {
    navigate('/advanced-material');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getSearchQueries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  // eslint-disable-next-line complexity
  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }

    const entity = {
      ...advancedMaterialEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...advancedMaterialEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="coconApp.advancedMaterial.home.createOrEditLabel" data-cy="AdvancedMaterialCreateUpdateHeading">
            <Translate contentKey="coconApp.advancedMaterial.home.createOrEditLabel">Create or edit a AdvancedMaterial</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="advanced-material-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('coconApp.advancedMaterial.molecularFormula')}
                id="advanced-material-molecularFormula"
                name="molecularFormula"
                data-cy="molecularFormula"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('coconApp.advancedMaterial.trivialName')}
                id="advanced-material-trivialName"
                name="trivialName"
                data-cy="trivialName"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/advanced-material" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AdvancedMaterialUpdate;
